<template>
    <section>
        <!-- Position left -->
        <o-breadcrumb position="left">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Position center -->
        <o-breadcrumb position="centered">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Position right -->
        <o-breadcrumb position="right">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>
    </section>
</template>
